import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { RiSearch2Line } from "react-icons/ri";

const Search = ({ isDarkMode }) => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [recentSearches, setRecentSearches] = useState([]);
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const savedSearches = JSON.parse(localStorage.getItem("recentSearches")) || [];
    const now = Date.now();
    const filteredSearches = savedSearches.filter((item) => now - item.timestamp < 3 * 24 * 60 * 60 * 1000);
    setRecentSearches(filteredSearches);
    localStorage.setItem("recentSearches", JSON.stringify(filteredSearches));
  }, []);

  const handleSearchIconClick = () => {
    setShowSearch(!showSearch);
    setSearchResults([]);
  };

  const handleSearchInputChange = async (e) => {
    const keyword = e.target.value;
    setSearchTerm(keyword);

    if (keyword.trim() !== "") {
      try {
        const response = await axios.get(
          `https://phimapi.com/v1/api/tim-kiem?keyword=${keyword}&limit=10`
        );
        const results = response.data.data.items || [];
        setSearchResults(results);
      } catch (error) {
        console.error("Error fetching search results:", error);
        setSearchResults([]);
      }
    } else {
      setSearchResults([]);
    }
  };

  const handleSearchResultClick = (movie) => {
    navigate(`/phim/${movie.slug}`);
    setShowSearch(false);
    setSearchTerm("");
    setSearchResults([]);
  
    const updatedSearches = [
      { slug: movie.slug, name: movie.name, poster: movie.poster, timestamp: Date.now() }, 
      ...recentSearches.filter((m) => m.slug !== movie.slug),
    ].slice(0, 3);
  
    setRecentSearches(updatedSearches);
    localStorage.setItem("recentSearches", JSON.stringify(updatedSearches));
  };
  

  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setShowSearch(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div style={{ position: "relative" }} ref={searchRef}>
      <div style={{width:"24px", height:"24px", color:"orange", display:"flex", justifyContent:"center", alignItems:"center"}}>
        <RiSearch2Line 
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleSearchIconClick} 
          style={{width:"20px", height:"20px", backgroundColor: isHovered ? "rgba(246, 143, 24, 0.1)" : "transparent", borderRadius: "4px"}}/>
      </div>
      {/* <img
        src="/search-icon.svg"
        alt="Search"
        style={{ cursor: "pointer", width: "24px", height: "24px", backgroundColor: isHovered ? "rgba(246, 143, 24, 0.1)" : "transparent", borderRadius: "4px" }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleSearchIconClick}
      /> */}
      {showSearch && (
        <div className="search-container"
        >
          <input
            type="text"
            placeholder="Tìm kiếm phim..."
            value={searchTerm}
            onChange={handleSearchInputChange}
          />
          <ul
            style={{
              listStyleType: "none",
              margin: 0,
              padding: 0,
              maxHeight: "200px",
              overflowY: "auto",
            }}
          >
            {searchResults.map((movie) => (
              <li
                key={movie._id}
                style={{
                  marginBottom: "10px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop : "10px",
                }}
                onClick={() => handleSearchResultClick(movie)}
              >
                <img
                  src={"/default-placeholder.svg"}
                  alt={movie.name}
                  style={{
                    width: "24px",
                    height: "24px",
                  }}
                />
                <span>{movie.name}</span>
              </li>
            ))}
            {recentSearches.length > 0 && (
              <div>
                <h4 style={{ fontSize: "14px", margin: "10px 0 5px" }}>Tìm kiếm gần đây</h4>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                  {recentSearches.map((movie) => (
                    <li
                      key={movie._id}
                      style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "10px", marginBottom: "5px" }}
                      onClick={() => handleSearchResultClick(movie)}
                    >
                      <img src={movie.poster || "/default-placeholder.svg"} alt={movie.name} style={{ width: "30px", height: "30px", borderRadius: "4px" }} />
                      <span>{movie.name}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Search;
